import moment from "moment";
import { intl } from "LocaleWrapper";
import { useQuery } from "@apollo/client";

import { Card, PageHeader } from "@cofano/cck";
import { Box, Typography } from "@mui/material";

import useLayout from "components/layout/useLayout";
import Helmet from "components/helmet/Helmet";

import { Language } from "imports/Utils";

import ProductsIdtfTable from "view/products/components/table/ProductsIdtfTable";
import ProductIdtfDetails from "view/products/components/details/ProductIdtfDetails";

import { GetIdtfProductListDocument } from "__generated__/view/products/graphql/product.queries.generated";
import { IdtfGoodFragment} from "__generated__/view/products/graphql/product.fragments.generated";

const ProductsIdtf = () => {

	const { data, loading }   = useQuery(GetIdtfProductListDocument);

	const layout = useLayout();

	const handleRowClick = (row: IdtfGoodFragment) => {
		layout.setDrawerSettings({
			open: true,
			title: intl.formatMessage({ id: "PRODUCT" }),
			content: (
				<Box p={2}>
					<ProductIdtfDetails idtfGood={row} />
				</Box>
			),
			size: "normal",
			variant: "overlay",
		});
	};

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
						{Language("PRODUCT_IDTF")}

						{data?.idtfProductList?.publicationDate && (
							<Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
								<Typography variant="caption" sx={{ lineHeight: 1, fontWeight: 600 }}>
									{Language("PRODUCT_IDTF_PUBLICATION")}:
								</Typography>

								<Typography variant="caption" sx={{ lineHeight: 1, fontWeight: 600 }}>
									{moment(data?.idtfProductList?.publicationDate).format("L")}
								</Typography>
							</Box>
						)}
					</Box>

					<Helmet title={intl.formatMessage({ id: "PRODUCT_IDTF" })} />
				</PageHeader.Title>
			</PageHeader>

			<Card disablePadding>
				<ProductsIdtfTable
					content={data?.idtfProductList?.goods || []}
					contentLoading={loading}
					onRowClick={handleRowClick} />
			</Card>
		</div>
	);
};

export default ProductsIdtf;
